export default function isExternal(url: string) {
  try {
    const parsedUrl = new URL(url, process.env.NEXT_PUBLIC_APP_URL);
    return !parsedUrl.origin.includes("elements");
  } catch (e) {
    // If URL parsing fails, treat it as an external link
    return false;
  }
}
